import { Button, FormHelperText, TextField } from "@mui/material";
import { useFormik } from "formik";
import { useSnackbar } from "notistack5";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { updateCacheSessDataApi } from "src/Api/Services/SystemConfiguration";
import { cacheSessFieldData } from "./cacheSessFieldData";

const UpdateCacheSession = ({ data, fetchData }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formik = useFormik({
    initialValues: data,
    onSubmit: () => {
      handleSubmitApiCall();
    },
  });
  const {
    errors,
    touched,
    handleSubmit,
    isSubmitting,
    values,
    handleBlur,
    resetForm,
    setSubmitting,
    handleChange,
  } = formik;

  const handleSubmitApiCall = async () => {
    try {
      const { data } = await updateCacheSessDataApi(values);
      if (data.status) {
        fetchData();
        resetForm();
      }
      enqueueSnackbar(data.message, {
        variant: data.status ? "success" : "error",
      });
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
    setSubmitting(false);
  };
  return (
    <form onSubmit={handleSubmit}>
      <Row>
        {cacheSessFieldData(values).map((item, index) => (
          <Col md={12} xs={12} xl={3} key={index}>
            {(item.type === "text" || item.type === "number") && (
              <TextField
                type={item.type}
                placeholder={item.placeHolder}
                size="normal"
                label={item.label}
                name={item.name}
                value={item.value}
                onChange={handleChange}
                error={errors[item.name] && touched[item.name]}
                fullWidth
                onBlur={handleBlur}
                className={index > 3 ? "mt-4" : ""}
              />
            )}
            {errors[item.name] && touched[item.name] && (
              <FormHelperText error id="component-error-text">
                {errors[item.name]}
              </FormHelperText>
            )}
          </Col>
        ))}
      </Row>
      <div className="text-center mt-4">
        <Button variant="contained" type="submit" disabled={isSubmitting}>
          Submit
        </Button>
      </div>
    </form>
  );
};
export default UpdateCacheSession;
